<div class="header-content">
    <div [ngClass]="part1Classname" class="header__part1">
<!--        <app-home-button></app-home-button>-->
<!--        <app-menu-button></app-menu-button>-->
<!--      <app-logo></app-logo>-->
      <img src="/assets/logos/logo_pa_blanc.png" alt="Logo" class="logo">

      <!--        <app-menu-desktop></app-menu-desktop>-->
    </div>
    <div class="header__part2">
        <app-user-connected></app-user-connected>
        <app-language-button></app-language-button>
    </div>
</div>

